import { Component, Mixins } from 'vue-property-decorator';
// @ts-ignore
import listPageMixin, { createSlotComp } from '@root/common/mixins/list-page/list-page.vue';
import uiConfig from './pageBootstrap.json';
import addDialog from './add.vue';
import exports from '../card-create/components/exports.vue';
import { stoExcelExport } from '@/api/fixed-car-management';

@Component({
  name: 'CardCreate',
  components: {
    exports,
    operation: createSlotComp('<span></span>'),
    dialogDefine: createSlotComp(
      `<div>
    <addDialog @cancel="vm.detailModel=null"
                      @submit="vm.handleAdd"
                      :visible="vm.detailModel?true:false"
                      v-if="vm.detailModel!=null && '信息变更 新增'.split(' ').includes(vm.detailDialogType)"
                      :vm="vm"
                      ref="addDialog" />
    </div>`,
      {
        addDialog
      }
    ),
    exportArea: createSlotComp(`<span>
    <Authorized resource="system:financial:export">
    <a-button @click="vm.exportCord"
                type="primary"
                icon="export"
                ghost
              >导出</a-button></Authorized>
    </span>`)
  }
})
export default class CardCreate extends Mixins(listPageMixin) {
  // addDialogVisible = false
  // handleOperateBtnClickCallback(actionDesc) {
  //   if (actionDesc.label == '信息变更') {
  //     this.addDialogVisible = true
  //   }
  // }
  downLoadErrMsgLoading = false;
  async exportCord() {
    console.log('this.filterParam--:', this.filterParam);
    try {
      if (this.downLoadErrMsgLoading) return;
      this.downLoadErrMsgLoading = true;
      const res = await stoExcelExport(
        { ...this.filterParam, parkIds: this.filterParam.parkIds.join(',') },
        '储值卡业务办理'
      );
      console.log(res);
    } catch (e) {
      console.log(e);
    } finally {
      this.downLoadErrMsgLoading = false;
    }
  }
  async handleAdd(fd: { parkId: string; parkName: any; storedCardBalanceDetailList: any }, cb: () => void) {
    fd = this.lodash.cloneDeep(fd);
    fd.parkId = [].concat(fd.parkId || fd.parkName).join(',');
    delete fd.storedCardBalanceDetailList;

    this.correntFormDataLikeMomentEtcDot(fd);
    this.mixedUtils.log('after fdddddddddd:', fd);
    const promise = this.createHttp(this.getDialogConfigByDialogLabel().behaviorConfig.onConfirm, fd);
    promise.catch(cb);
    await promise;
    this.operateSuccessWithReload();
    cb();
  }
  async handleNewBtnClick() {
    const row = await this.createHttp(null, this.UI.新增弹框配置.behaviorConfig.onLaunch.model);

    this.mixedUtils.log('row--:', row);
    this.handleOperateBtnClick(
      {
        label: '新增',
        action: '仅使用弹框服务'
      },
      row
    );
  }

  customPrimaryUIConfig = uiConfig;

  get computedPagination() {
    return {
      ...this.pagination,
      pageSize: this.pagination.pageSize,
      showTotal: () => `总共 ${this.totalRecordNumFromHttpRes} 条`
    };
  }
}
